import { useTranslation } from 'react-i18next';

export type TerminalStatus = keyof ReturnType<typeof useTerminalStatus>;

export const useTerminalStatus = () => {
    const { t } = useTranslation();
    return {
        TAKING_ORDERS: t('STATUS.TAKING_ORDERS'),
        TEMPORARY_OUT_OF_USE: t('STATUS.TEMPORARY_OUT_OF_USE'),
        CLOSED: t('STATUS.CLOSED'),
        OUT_OF_ORDER: t('STATUS.OUT_OF_ORDER'),
    };
};

export const TERMINAL_STATUS_COLOR: Record<
    string,
    'success' | 'error' | 'default' | 'primary' | 'secondary' | 'info' | 'warning'
> = {
    TAKING_ORDERS: 'success',
    TEMPORARY_OUT_OF_USE: 'warning',
    CLOSED: 'error',
    OUT_OF_ORDER: 'error',
};

export const useFilterSelectOptions = () => {
    const terminalStatus = useTerminalStatus();

    return Object.keys(terminalStatus).map((status) => ({
        value: status,
        label: terminalStatus[status],
    }));
};
